import React, { useState, useEffect } from "react";
import { Select as AntSelect } from "antd";
import styled from "styled-components";
import { getMetropolitanStatisticalAreas } from "../../api/MSA";

const { Option } = AntSelect;

const Select = styled(AntSelect)`
  width: 100%;
`;

function SelectMSA({ onChange, value, disabled }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [metropolitanStatisticalAreas, setMetropolitanStatisticalAreas] = useState<any[]>([]);

  useEffect(() => {
    void fetchMetropolitanStatisticalAreas();
  }, []);

  const fetchMetropolitanStatisticalAreas = async () => {
    const metropolitanStatisticalAreasResult = await getMetropolitanStatisticalAreas();
    setMetropolitanStatisticalAreas(
      [{ name: "No MSA Present" }].concat(metropolitanStatisticalAreasResult)
    );
  };

  return (
    <Select
      showSearch={true}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="MSA"
      data-testid="hcpDrawer-msa-dropdown"
    >
      {metropolitanStatisticalAreas.map(({ name }) => (
        <Option key={name} value={name}>
          {name}
        </Option>
      ))}
    </Select>
  );
}

export { SelectMSA };
